import { render, staticRenderFns } from "./RequestSpecialistList.vue?vue&type=template&id=1cc07240"
import script from "./RequestSpecialistList.vue?vue&type=script&lang=js"
export * from "./RequestSpecialistList.vue?vue&type=script&lang=js"
import style0 from "./RequestSpecialistList.vue?vue&type=style&index=0&id=1cc07240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports